import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { LightbulbIcon, FileTextIcon, MicIcon, ImageIcon, ScissorsIcon, UploadIcon } from 'lucide-react';
const steps = [{
  icon: LightbulbIcon,
  label: 'Idea'
}, {
  icon: FileTextIcon,
  label: 'Guion'
}, {
  icon: MicIcon,
  label: 'Voz con IA'
}, {
  icon: ImageIcon,
  label: 'Creación de imágenes o video'
}, {
  icon: ScissorsIcon,
  label: 'Edición simple'
}, {
  icon: UploadIcon,
  label: 'Publicación'
}];
export function ImpactSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-tertiary" data-id="element-81">
      <div className="max-w-5xl mx-auto" data-id="element-82">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-6 text-center" data-id="element-83">
          El sistema simple para crear contenido desde cero
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-lg md:text-xl text-text-secondary text-center mb-16 max-w-2xl mx-auto" data-id="element-84">
          No es teoría. Es un proceso paso a paso:
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 mb-12" data-id="element-85">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.15 + index * 0.08
          }} className="flex flex-col items-center gap-3 p-6 bg-dark-bg/50 rounded-xl border border-dark-tertiary" data-id="element-86">
                <div className="flex items-center justify-center w-14 h-14 bg-accent/10 rounded-full" data-id="element-87">
                  <Icon className="w-7 h-7 text-accent" data-id="element-88" />
                </div>
                <div className="flex items-center gap-2" data-id="element-89">
                  <span className="text-accent/50 font-bold text-sm" data-id="element-90">
                    {index + 1}.
                  </span>
                  <span className="text-text-primary font-semibold text-sm text-center" data-id="element-91">
                    {step.label}
                  </span>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="text-center text-accent text-lg font-medium" data-id="element-92">
          En pocos minutos puedes tener contenido listo para compartir.
        </motion.p>
      </div>
    </section>;
}